import React, { useState, useEffect } from 'react';
import { SlideDots, SlideItem, SliderHolder, SliderWrapper } from './ImageSlider.styles';


const ImageSlider = ({ data }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [length, setLength] = useState(data.length);

    const [touchPosition, setTouchPosition] = useState(null);

    useEffect(() => {
        setLength(data.length);
    }, [data]);

    const next = () => {
        if (currentIndex < length - 1) {
            setCurrentIndex(prevState => prevState + 1);
        }
    };

    const prev = () => {
        if (currentIndex > 0) {
            setCurrentIndex(prevState => prevState - 1);
        }
    };

    const handleTouchStart = e => {
        const touchDown = e.touches[0].clientX;
        setTouchPosition(touchDown);
    };

    const handleTouchMove = e => {
        const touchDown = touchPosition;

        if (touchDown === null) {
            return;
        }

        const currentTouch = e.touches[0].clientX;
        const diff = touchDown - currentTouch;

        if (diff > 5) {
            next();
        }

        if (diff < -5) {
            prev();
        }

        setTouchPosition(null);
    };

    const timeoutRef = React.useRef(null);

    function resetTimeout() {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    }

    React.useEffect(() => {
        resetTimeout();
        timeoutRef.current = setTimeout(
            () =>
                setCurrentIndex(prevIndex =>
                    prevIndex === data.length - 1 ? 0 : prevIndex + 1,
                ),
            2500,
        );

        return () => {
            resetTimeout();
        };
    }, [currentIndex]);
    return (
        <SliderWrapper>
            <SliderHolder
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
                {
                    data && data.length > 0 &&
                    data.map((item, index) => (
                        <SlideItem key={item.id}>
                            <img src={item.imgUrl} />
                        </SlideItem>
                    ))
                }
            </SliderHolder>
            <SlideDots className="slideshowDots">
                {data.map((_, idx) => (
                    <div
                        key={idx}
                        className={`slideshowDot${currentIndex === idx ? ' active' : ''}`}
                        onClick={() => {
                            setCurrentIndex(idx);
                        }}></div>
                ))}
            </SlideDots>
        </SliderWrapper>
    )
}

export default ImageSlider;